// Fluxo de projetos terceirizados: etapas e dependências próprias (subconjunto
// das 24 + a etapa 25 "Compra do primeiro lote"). Puro, reutilizável.
import type { Phase, ProjectType, StageTemplate } from './types';

/** Etapas do fluxo terceirizado, na ordem das fases. */
export const TERCEIRIZADO_NS = [1, 2, 3, 6, 8, 10, 11, 12, 17, 18, 25, 21, 23, 24];

/** Dependências específicas do fluxo terceirizado. */
const TERCEIRIZADO_DEPS: Record<number, number[]> = {
  1: [],
  2: [1],
  3: [1],
  6: [3],
  8: [6],
  10: [8],
  11: [8],
  12: [8],
  17: [8],
  18: [10, 11, 12, 17],
  25: [10, 11, 12, 17],
  21: [18, 25],
  23: [18, 25],
  24: [18, 25],
};

const PHASE_ORDER: Record<Phase, number> = { PD1: 1, PD2: 2, PD3: 3, PD4: 4, PD5: 5 };

/**
 * Devolve o template de etapas a usar para um projeto, conforme o tipo.
 * - interno: as 24 etapas padrão (exclui a 25).
 * - terceirizado: apenas o subconjunto + a etapa 25, com dependências próprias.
 */
export function buildTemplateForType(
  base: StageTemplate[],
  type: ProjectType,
): StageTemplate[] {
  if (type !== 'terceirizado') return base.filter((t) => t.n <= 24);
  const byN = new Map(base.map((t) => [t.n, t]));
  return TERCEIRIZADO_NS.map((n) => {
    const b = byN.get(n);
    return {
      n,
      phase: (b?.phase ?? (n === 25 ? 'PD4' : 'PD1')) as Phase,
      name: b?.name ?? (n === 25 ? 'Compra do primeiro lote' : `Etapa ${n}`),
      defaultDays: b?.defaultDays ?? 30,
      areaKeys: b?.areaKeys ?? (n === 25 ? ['suprimentos'] : []),
      deps: TERCEIRIZADO_DEPS[n] ?? [],
    };
  }).sort((a, b) => PHASE_ORDER[a.phase] - PHASE_ORDER[b.phase] || a.n - b.n);
}
